module.exports = __webpack_public_path__ + "static/media/stora.8df38f03.mp3";